var map = {
	"./": 104,
	"./es": 84,
	"./es/": 84,
	"./es/admin": 107,
	"./es/admin.d": 139,
	"./es/admin.d.ts": 139,
	"./es/admin.js": 107,
	"./es/cattle_species": 106,
	"./es/cattle_species.d": 140,
	"./es/cattle_species.d.ts": 140,
	"./es/cattle_species.js": 106,
	"./es/import_export": 108,
	"./es/import_export.d": 141,
	"./es/import_export.d.ts": 141,
	"./es/import_export.js": 108,
	"./es/index": 84,
	"./es/index.d": 142,
	"./es/index.d.ts": 142,
	"./es/index.js": 84,
	"./es/notebook": 105,
	"./es/notebook.d": 143,
	"./es/notebook.d.ts": 143,
	"./es/notebook.js": 105,
	"./gl/cattle_species": 129,
	"./gl/cattle_species.d": 144,
	"./gl/cattle_species.d.ts": 144,
	"./gl/cattle_species.js": 129,
	"./index": 104,
	"./index.d": 145,
	"./index.d.ts": 145,
	"./index.js": 104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;